<template>
  <button
    ref="episodeButton"
    :class="currentEpisode ? `${className} active` : className"
    :data-src="episodeUrl"
    :show-pemlink="episodePermlink"
    :disabled="isBuffering"
    @click="getDataSrc()"
  >
    <img
      v-if="!isBuffering"
      class="episode-icon"
      :class="{ play: !isPlaying }"
      :src="require('@/assets/icons/svg/' + buttonIcon)"
    />
    <Loading v-else />
  </button>
</template>
<script>
let currentId = null;
import '../../plugins/mixcloudWidgetApi.js';
import Loading from '@/components/ui/Loading.vue';
import { bus } from '../../main';
export default {
  name: 'EpisodeButton',
  components: {
    Loading
  },
  props: {
    episodeUrl: {
      type: String,
      required: true
    },
    episodePermlink: {
      type: String,
      required: true
    },
    artist: {
      type: Object,
      required: true
    },
    podcast: {
      type: Object,
      default: null,
      required: false
    },
    episodeTitle: {
      type: String,
      required: true
    },
    className: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      isPlaying: false,
      isBuffering: false,
      currentPlaying: false,
      play: 'play-component-icon.svg',
      pause: 'pause-component-icon.svg',
      showUrl: null,
      isSelected: false
    };
  },

  computed: {
    buttonIcon() {
      return this.isPlaying ? this.pause : this.play;
    },
    currentEpisode() {
      return this.isPlaying
        ? this.$emit('current-playing', true)
        : this.$emit('current-playing', false);
    }
  },

  created() {
    bus.$on('current-id', data => {
      currentId = data;
      this.initShowButtons();
    });
  },

  mounted() {
    this.$nextTick(function() {
      this.mixcloudListener();
    });
  },

  activated() {
    this.mixcloudListener();
  },

  methods: {
    initShowButtons() {
      this.isPlaying = false;
    },
    // TODO => needs refactoring
    mixcloudListener() {
      setTimeout(() => {
        let showButtonSrc = this.$refs.episodeButton.dataset.src;
        var encoded = encodeURIComponent(showButtonSrc);
        let id = btoa(encoded).replace(/=/gi, '');
        let inhaltone = this;
        var mixcloudParent = document.getElementById('mixcloudContainer');
        if (mixcloudParent.hasChildNodes()) {
          var matches = mixcloudParent.querySelectorAll('iframe[id=' + id + ']');
          if (matches.length !== 0) {
            currentId = id;
            inhaltone.isBuffering = false;
            inhaltone.isPlaying = true;
            const widget = Mixcloud.PlayerWidget(document.getElementById(id));
            widget.ready.then(function() {
              widget.events.pause.on(pauseListener => {
                // console.log('pause listener');
                inhaltone.isPlaying = false;
                inhaltone.isSelected = false;
                inhaltone.isBuffering = false;
              });
              widget.events.play.on(playListener => {
                // console.log('play listener');
                inhaltone.isPlaying = true;
                inhaltone.isSelected = true;
                inhaltone.isBuffering = false;
              });
              widget.events.buffering.on(() => {
                // console.log('buffering listener');
                inhaltone.isPlaying = false;
                inhaltone.isBuffering = true;
              });
            });
          }
        }
      }, 500);
    },
    getDataSrc() {
      this.showUrl = null;
      let inhaltone = this;
      var mixsrc = event.currentTarget.getAttribute('data-src');
      var encoded = encodeURIComponent(mixsrc);
      var id = btoa(encoded).replace(/=/gi, '');
      var mixcloudParent = document.getElementById('mixcloudContainer');
      var inhalt = mixcloudParent.querySelectorAll('iframe[id=' + id + ']');
      if (currentId === id) {
        // console.log('here => currentId === id');
        const widget = Mixcloud.PlayerWidget(document.getElementById(id));
        widget.ready.then(function() {
          widget.togglePlay();
          widget.events.pause.on(pauseListener => {
            // console.log('on playing');
            inhaltone.playButton = 'play_arrow';
            inhaltone.isPlaying = false;
            inhaltone.isSelected = false;
          });
          widget.events.play.on(playListener => {
            inhaltone.isPlaying = true;
            inhaltone.isSelected = true;
            inhaltone.isBuffering = false;
            // console.log(playListener, 'IS PLAYING');
          });
          widget.events.buffering.on(playListener => {
            inhaltone.isBuffering = true;
          });
        });
        return;
      }
      if (inhalt.length === 0) {
        // console.log('here inhalt.length === 0');
        this.isBuffering = true;
        var showPpermlink = event.currentTarget.getAttribute('show-pemlink');
        this.showUrl = showPpermlink;
        var mixcloudRoot = document.getElementById('mixcloudWrapper');
        const mixcloudModule = document.getElementById('mixcloudModule');
        let iframe = document.createElement('iframe');
        iframe.setAttribute('id', id);
        iframe.setAttribute(
          'src',
          `https://www.mixcloud.com/widget/iframe/?hide_cover=1&mini=1&light=1&autoplay=1&feed=${mixsrc}`
        );
        iframe.setAttribute('class', 'w-100 h-60');
        iframe.setAttribute('frameBorder', '0');
        iframe.setAttribute('allow', 'autoplay');

        this.sendDestroyMixcloud();

        mixcloudModule.classList.remove('slide-out-bottom');
        mixcloudModule.classList.add('slide-in-bottom');
        this.sendDataShow();
        this.sendShowRoute();
        this.sendPodcastData();
        this.sendPodcastRoute();
        setTimeout(() => {
          mixcloudParent.appendChild(iframe);
          mixcloudRoot.style.display = 'block';
          currentId = id;
        }, 500);
        setTimeout(() => {
          this.mixcloudListener();
        }, 1000);
      }
      currentId = id;
      this.sendDataRadio();
    },
    // TODO => Use VUEX instead of bus
    sendPodcastData() {
      if (this.podcast) {
        let podcastData = this.podcast.name;
        bus.$emit('send-podcast-data', podcastData);
      } else {
        bus.$emit('send-podcast-data', null);
      }
    },
    sendPodcastRoute() {
      if (this.podcast) {
        let podcastRoute = this.podcast.permlink;
        bus.$emit('send-podcast-route', podcastRoute);
      } else {
        bus.$emit('send-podcast-route', null);
      }
    },
    sendDataShow() {
      let showDataStringCombo = this.episodeTitle + ' w/ ' + this.artist.name;
      bus.$emit('send-data-show', showDataStringCombo);
    },
    sendShowRoute() {
      let showDataRoute = this.showUrl;
      bus.$emit('send-show-route', showDataRoute);
    },
    sendDestroyMixcloud() {
      bus.$emit('destroy-mixcloud', 'inhalt');
    },
    sendDataRadio() {
      bus.$emit('radio-status', false);
    }
  }
};
</script>
<style scoped lang="scss">
.black-circle {
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 46px;
  height: 46px;
  border-radius: 100%;
  background-color: black;
  font-size: 14px;
  margin-left: 15px;
  img {
    width: 20px;
    height: 16px;
    display: block;
    &.play {
      margin-left: 4px;
    }
  }
}
</style>
